import React from 'react';
import styled from 'styled-components';
import { Typography } from '@material-ui/core';

const StyledContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid #a6a6a6;
  .header {
    display: flex;
    background-color: #1769aa;
    color: #fff;
    justify-content: space-between;
  }
`;

const StyledContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: #e6e6e6;
  justify-content: center;
  color: #a6a6a6;
  text-align: center;
`;

type UnrenderedFilesViewerProps = {
  fileName?: string;
  fileSize?: number;
  className?: string;
};

const UnrenderedFilesViewer: React.FC<UnrenderedFilesViewerProps> = ({
  fileName,
  fileSize,
  className
}) => {
  const formatFileSize = (bytes: number, decimals = 2) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  };

  return (
    <StyledContainer className={className}>
      <div className='header'>
        <Typography variant='subtitle2' style={{ margin: 10 }}>
          File Preview Unavailable
        </Typography>
        <Typography
          variant='subtitle2'
          style={{ margin: 10, color: '#a1c1e2' }}
        >
          {fileName}
        </Typography>
      </div>
      <StyledContent>
        <div>
          <Typography
            variant='subtitle2'
            style={{ marginBottom: 10, fontSize: 16 }}
          >
            {fileName}
          </Typography>
          <Typography
            variant='subtitle2'
            style={{ marginBottom: 10, fontSize: 12 }}
          >
            {formatFileSize(fileSize || 0)}
          </Typography>
        </div>
      </StyledContent>
    </StyledContainer>
  );
};

export default UnrenderedFilesViewer;
